import $ from 'jquery';

export default class Textarea {
    constructor() {
        if($('textarea').length) {
            $('textarea').each(function () {
                this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
            }).on('input', function () {
                this.style.height = 0;
                this.style.height = (this.scrollHeight) + 'px';
            });
        };
    };
};
